import * as React from 'react';

class ArrowUpSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 26 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon arrow-up-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          d="M14.5102 1.57964C14.0831 1.20416 13.5339 0.997071 12.9652 0.997071C12.3965 0.997071 11.8473 1.20416 11.4202 1.57964C7.51856 5.09009 4.07477 9.07816 1.17022 13.4496C1.09538 13.5592 1.04312 13.6827 1.01647 13.8127C0.989813 13.9427 0.989308 14.0767 1.01498 14.2069C1.04065 14.3371 1.09198 14.4609 1.16599 14.5711C1.23999 14.6813 1.33518 14.7756 1.44602 14.8486C1.55685 14.9216 1.68111 14.9718 1.81155 14.9963C1.94199 15.0208 2.07599 15.0191 2.20576 14.9913C2.33553 14.9634 2.45846 14.9101 2.56739 14.8342C2.67631 14.7584 2.76906 14.6617 2.84022 14.5496C5.65422 10.3176 8.99053 6.45713 12.7702 3.05964C12.8024 3.03449 12.8395 3.0162 12.879 3.00588C12.9186 2.99557 12.9598 2.99344 13.0002 2.99964C13.0667 2.99295 13.1337 2.99295 13.2002 2.99964C17.1502 6.99964 20.4902 10.4296 23.2002 14.5196C23.2713 14.6312 23.3638 14.7275 23.4723 14.803C23.5809 14.8786 23.7033 14.9319 23.8326 14.9598C23.9619 14.9877 24.0954 14.9896 24.2254 14.9656C24.3555 14.9415 24.4795 14.8919 24.5902 14.8196C24.8094 14.673 24.9618 14.4457 25.0143 14.1873C25.0667 13.9288 25.0149 13.6601 24.8702 13.4396C21.9343 9.06256 18.453 5.07717 14.5102 1.57964Z"
          fill="#EA1C0A"
        />
      </svg>
    );
  }
}

export default ArrowUpSvg;
